<template>
	<div class="map-view">
		<img
			:src="urlImage"
			alt="ubicación de tiendas"
			class="map-view-image"
		/>
	</div>
</template>

<script>
	export default {
		name: 'map-view',
		props: {
			urlImage: String,
		},
	};
</script>

<style lang="scss" scoped>
	.map-view {
		height: calc(100vh - 131px);
		left: 0;
		overflow: hidden;
		position: absolute;
		right: 0;

		@media (min-width: 936px) {
			height: calc(100vh - 194px);
		}

		img {
			width: 100%;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/map-view.vue